import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
export const ReadOnlyField = _ref => {
  let {
    field
  } = _ref;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldComponent, _extends({}, field.properties, {
    id: field.id,
    externalData: externalData
  }));
};
//# sourceMappingURL=read-only-field.js.map